export default {
    bgWhite: '#ffffff',
    borderColor: '#ced6d9',
    headerColor: '#f5f5f7',
    iconColor: '#616C79',
    primaryTextColor: '#313131',
    secondaryTextColor: '#828894',
};
